import React from 'react';
import { Portal } from 'react-portal';

const Toolbar = (props) => {
  const getNode = () => {
    if (typeof window !== 'undefined') {
      return document.getElementById('main-toolbar');
    }
  };

  return (
    <Portal {...props}
      node={getNode()} />
  );
};

export default Toolbar;
